// !! Keep in sync with API Permissions !!
// eslint-disable-next-line no-var
export var PERMISSIONS = {
  // User Management
  get VIEW_USER_GENERAL() {
    return {
      value: "VIEW_USER_GENERAL",
    }
  },
  get EDIT_USER_GENERAL() {
    return {
      value: "EDIT_USER_GENERAL",
      depends_on: [this.VIEW_USER_GENERAL],
    }
  },
  get DELETE_USER_GENERAL() {
    return {
      value: "DELETE_USER_GENERAL",
      depends_on: [this.EDIT_USER_GENERAL],
    }
  },

  // User Inner Layer: Company
  get VIEW_USER_COMPANY_GENERAL() {
    return {
      value: "VIEW_USER_COMPANY_GENERAL",
      depends_on: [this.VIEW_USER_POSITION_GENERAL],
    }
  },
  get EDIT_USER_COMPANY_GENERAL() {
    return {
      value: "EDIT_USER_COMPANY_GENERAL",
      depends_on: [this.VIEW_USER_COMPANY_GENERAL],
    }
  },
  get VIEW_USER_COMPANY_TOTAL_HOLIDAY_DAYS() {
    return {
      value: "VIEW_USER_COMPANY_TOTAL_HOLIDAY_DAYS",
    }
  },
  get EDIT_USER_COMPANY_TOTAL_HOLIDAY_DAYS() {
    return {
      value: "EDIT_USER_COMPANY_TOTAL_HOLIDAY_DAYS",
      depends_on: [this.VIEW_USER_COMPANY_TOTAL_HOLIDAY_DAYS],
    }
  },
  get VIEW_USER_COMPANY_SOCIAL_INSURANCE() {
    return {
      value: "VIEW_USER_COMPANY_SOCIAL_INSURANCE",
    }
  },
  get EDIT_USER_COMPANY_SOCIAL_INSURANCE() {
    return {
      value: "EDIT_USER_COMPANY_SOCIAL_INSURANCE",
      depends_on: [this.VIEW_USER_COMPANY_SOCIAL_INSURANCE],
    }
  },
  get VIEW_USER_COMPANY_SOCIAL_INSURANCE_NUMBER() {
    return {
      value: "VIEW_USER_COMPANY_SOCIAL_INSURANCE_NUMBER",
    }
  },
  get EDIT_USER_COMPANY_SOCIAL_INSURANCE_NUMBER() {
    return {
      value: "EDIT_USER_COMPANY_SOCIAL_INSURANCE_NUMBER",
      depends_on: [this.VIEW_USER_COMPANY_SOCIAL_INSURANCE_NUMBER],
    }
  },
  get VIEW_USER_COMPANY_PAY() {
    return {
      value: "VIEW_USER_COMPANY_PAY",
    }
  },
  get EDIT_USER_COMPANY_PAY() {
    return {
      value: "EDIT_USER_COMPANY_PAY",
      depends_on: [this.VIEW_USER_COMPANY_PAY],
    }
  },

  get VIEW_USER_SYSTEM() {
    return {
      value: "VIEW_USER_SYSTEM",
    }
  },
  get EDIT_USER_SYSTEM() {
    return {
      value: "EDIT_USER_SYSTEM",
      depends_on: [this.VIEW_USER_SYSTEM],
    }
  },
  get VIEW_USER_FILE() {
    return {
      value: "VIEW_USER_FILE",
    }
  },
  get EDIT_USER_FILE() {
    return {
      value: "EDIT_USER_FILE",
      depends_on: [this.VIEW_USER_FILE],
    }
  },
  get DELETE_USER_FILE() {
    return {
      value: "DELETE_USER_FILE",
      depends_on: [this.EDIT_USER_FILE],
    }
  },
  get VIEW_USER_EXTENDED() {
    return {
      value: "VIEW_USER_EXTENDED",
    }
  },
  get EDIT_USER_EXTENDED() {
    return {
      value: "EDIT_USER_EXTENDED",
      depends_on: [this.VIEW_USER_EXTENDED],
    }
  },

  // Category Management
  get VIEW_CATEGORY_GENERAL() {
    return {
      value: "VIEW_CATEGORY_GENERAL",
    }
  },
  get EDIT_CATEGORY_GENERAL() {
    return {
      value: "EDIT_CATEGORY_GENERAL",
      depends_on: [this.VIEW_CATEGORY_GENERAL],
    }
  },
  get DELETE_CATEGORY_GENERAL() {
    return {
      value: "DELETE_CATEGORY_GENERAL",
      depends_on: [this.EDIT_CATEGORY_GENERAL],
    }
  },

  // Machine Management
  get VIEW_MACHINE_GENERAL() {
    return {
      value: "VIEW_MACHINE_GENERAL",
    }
  },
  get EDIT_MACHINE_GENERAL() {
    return {
      value: "EDIT_MACHINE_GENERAL",
      depends_on: [this.VIEW_MACHINE_GENERAL],
    }
  },
  get DELETE_MACHINE_GENERAL() {
    return {
      value: "DELETE_MACHINE_GENERAL",
      depends_on: [this.EDIT_MACHINE_GENERAL],
    }
  },
  get VIEW_MACHINE_PURCHASEPRICE() {
    return {
      value: "VIEW_MACHINE_PURCHASEPRICE",
    }
  },
  get EDIT_MACHINE_PURCHASEPRICE() {
    return {
      value: "EDIT_MACHINE_PURCHASEPRICE",
      depends_on: [this.VIEW_MACHINE_PURCHASEPRICE],
    }
  },

  // Supplier Management. One row: address, contacts and files are the supplier's general data. Its
  // prices answer to the machine and material purchase price rights, not to these (docs/suppliers.md).
  get VIEW_SUPPLIER_GENERAL() {
    return {
      value: "VIEW_SUPPLIER_GENERAL",
    }
  },
  get EDIT_SUPPLIER_GENERAL() {
    return {
      value: "EDIT_SUPPLIER_GENERAL",
      depends_on: [this.VIEW_SUPPLIER_GENERAL],
    }
  },
  get DELETE_SUPPLIER_GENERAL() {
    return {
      value: "DELETE_SUPPLIER_GENERAL",
      depends_on: [this.EDIT_SUPPLIER_GENERAL],
    }
  },

  // Material Management
  get VIEW_MATERIAL_GENERAL() {
    return {
      value: "VIEW_MATERIAL_GENERAL",
    }
  },
  get EDIT_MATERIAL_GENERAL() {
    return {
      value: "EDIT_MATERIAL_GENERAL",
      depends_on: [this.VIEW_MATERIAL_GENERAL],
    }
  },
  get DELETE_MATERIAL_GENERAL() {
    return {
      value: "DELETE_MATERIAL_GENERAL",
      depends_on: [this.EDIT_MATERIAL_GENERAL],
    }
  },
  get VIEW_MATERIAL_PURCHASEPRICE() {
    return {
      value: "VIEW_MATERIAL_PURCHASEPRICE",
    }
  },
  get EDIT_MATERIAL_PURCHASEPRICE() {
    return {
      value: "EDIT_MATERIAL_PURCHASEPRICE",
      depends_on: [this.VIEW_MATERIAL_PURCHASEPRICE],
    }
  },

  // Additional-Effort Management
  get VIEW_ADDITIONAL_EFFORT_GENERAL() {
    return {
      value: "VIEW_ADDITIONAL_EFFORT_GENERAL",
    }
  },
  get EDIT_ADDITIONAL_EFFORT_GENERAL() {
    return {
      value: "EDIT_ADDITIONAL_EFFORT_GENERAL",
      depends_on: [this.VIEW_ADDITIONAL_EFFORT_GENERAL],
    }
  },
  get DELETE_ADDITIONAL_EFFORT_GENERAL() {
    return {
      value: "DELETE_ADDITIONAL_EFFORT_GENERAL",
      depends_on: [this.EDIT_ADDITIONAL_EFFORT_GENERAL],
    }
  },
  get VIEW_ADDITIONAL_EFFORT_PRICE() {
    return {
      value: "VIEW_ADDITIONAL_EFFORT_PRICE",
    }
  },
  get EDIT_ADDITIONAL_EFFORT_PRICE() {
    return {
      value: "EDIT_ADDITIONAL_EFFORT_PRICE",
      depends_on: [this.VIEW_ADDITIONAL_EFFORT_PRICE],
    }
  },

  // Customer Management
  get VIEW_CUSTOMER_GENERAL() {
    return {
      value: "VIEW_CUSTOMER_GENERAL",
    }
  },
  get EDIT_CUSTOMER_GENERAL() {
    return {
      value: "EDIT_CUSTOMER_GENERAL",
      depends_on: [this.VIEW_CUSTOMER_GENERAL],
    }
  },
  get DELETE_CUSTOMER_GENERAL() {
    return {
      value: "DELETE_CUSTOMER_GENERAL",
      depends_on: [this.EDIT_CUSTOMER_GENERAL],
    }
  },
  get VIEW_CUSTOMER_CONTACT() {
    return {
      value: "VIEW_CUSTOMER_CONTACT",
    }
  },
  get EDIT_CUSTOMER_CONTACT() {
    return {
      value: "EDIT_CUSTOMER_CONTACT",
      depends_on: [this.VIEW_CUSTOMER_CONTACT],
    }
  },
  get DELETE_CUSTOMER_CONTACT() {
    return {
      value: "DELETE_CUSTOMER_CONTACT",
      depends_on: [this.EDIT_CUSTOMER_CONTACT],
    }
  },
  get VIEW_CUSTOMER_MACHINE() {
    return {
      value: "VIEW_CUSTOMER_MACHINE",
    }
  },
  get EDIT_CUSTOMER_MACHINE() {
    return {
      value: "EDIT_CUSTOMER_MACHINE",
      depends_on: [this.VIEW_CUSTOMER_MACHINE],
    }
  },
  get DELETE_CUSTOMER_MACHINE() {
    return {
      value: "DELETE_CUSTOMER_MACHINE",
      depends_on: [this.EDIT_CUSTOMER_MACHINE],
    }
  },
  get VIEW_CUSTOMER_MATERIAL() {
    return {
      value: "VIEW_CUSTOMER_MATERIAL",
    }
  },
  get EDIT_CUSTOMER_MATERIAL() {
    return {
      value: "EDIT_CUSTOMER_MATERIAL",
      depends_on: [this.VIEW_CUSTOMER_MATERIAL],
    }
  },
  get DELETE_CUSTOMER_MATERIAL() {
    return {
      value: "DELETE_CUSTOMER_MATERIAL",
      depends_on: [this.EDIT_CUSTOMER_MATERIAL],
    }
  },
  get VIEW_CUSTOMER_ADDITIONAL_EFFORT() {
    return {
      value: "VIEW_CUSTOMER_ADDITIONAL_EFFORT",
    }
  },
  get EDIT_CUSTOMER_ADDITIONAL_EFFORT() {
    return {
      value: "EDIT_CUSTOMER_ADDITIONAL_EFFORT",
      depends_on: [this.VIEW_CUSTOMER_ADDITIONAL_EFFORT],
    }
  },
  get DELETE_CUSTOMER_ADDITIONAL_EFFORT() {
    return {
      value: "DELETE_CUSTOMER_ADDITIONAL_EFFORT",
      depends_on: [this.EDIT_CUSTOMER_ADDITIONAL_EFFORT],
    }
  },
  get VIEW_CUSTOMER_FILE() {
    return {
      value: "VIEW_CUSTOMER_FILE",
    }
  },
  get EDIT_CUSTOMER_FILE() {
    return {
      value: "EDIT_CUSTOMER_FILE",
      depends_on: [this.VIEW_CUSTOMER_FILE],
    }
  },
  get DELETE_CUSTOMER_FILE() {
    return {
      value: "DELETE_CUSTOMER_FILE",
      depends_on: [this.EDIT_CUSTOMER_FILE],
    }
  },
  get VIEW_CUSTOMER_USERPOSITION() {
    return {
      value: "VIEW_CUSTOMER_USERPOSITION",
    }
  },
  get EDIT_CUSTOMER_USERPOSITION() {
    return {
      value: "EDIT_CUSTOMER_USERPOSITION",
      depends_on: [this.VIEW_CUSTOMER_USERPOSITION],
    }
  },
  get DELETE_CUSTOMER_USERPOSITION() {
    return {
      value: "DELETE_CUSTOMER_USERPOSITION",
      depends_on: [this.EDIT_CUSTOMER_USERPOSITION],
    }
  },
  get VIEW_CUSTOMER_SETTINGS() {
    return {
      value: "VIEW_CUSTOMER_SETTINGS",
    }
  },
  get EDIT_CUSTOMER_SETTINGS() {
    return {
      value: "EDIT_CUSTOMER_SETTINGS",
      depends_on: [this.VIEW_CUSTOMER_SETTINGS],
    }
  },

  get VIEW_CUSTOMER_MACHINE_SELLING_PRICE() {
    return {
      value: "VIEW_CUSTOMER_MACHINE_SELLING_PRICE",
    }
  },
  get EDIT_CUSTOMER_MACHINE_SELLING_PRICE() {
    return {
      value: "EDIT_CUSTOMER_MACHINE_SELLING_PRICE",
      depends_on: [this.VIEW_CUSTOMER_MACHINE_SELLING_PRICE],
    }
  },
  get VIEW_CUSTOMER_MACHINE_PURCHASE_PRICE() {
    return {
      value: "VIEW_CUSTOMER_MACHINE_PURCHASE_PRICE",
    }
  },
  get VIEW_CUSTOMER_MATERIAL_SELLING_PRICE() {
    return {
      value: "VIEW_CUSTOMER_MATERIAL_SELLING_PRICE",
    }
  },
  get EDIT_CUSTOMER_MATERIAL_SELLING_PRICE() {
    return {
      value: "EDIT_CUSTOMER_MATERIAL_SELLING_PRICE",
      depends_on: [this.VIEW_CUSTOMER_MATERIAL_SELLING_PRICE],
    }
  },
  get VIEW_CUSTOMER_MATERIAL_PURCHASE_PRICE() {
    return {
      value: "VIEW_CUSTOMER_MATERIAL_PURCHASE_PRICE",
    }
  },
  get VIEW_CUSTOMER_ADDITIONAL_EFFORT_SELLING_PRICE() {
    return {
      value: "VIEW_CUSTOMER_ADDITIONAL_EFFORT_SELLING_PRICE",
    }
  },
  get EDIT_CUSTOMER_ADDITIONAL_EFFORT_SELLING_PRICE() {
    return {
      value: "EDIT_CUSTOMER_ADDITIONAL_EFFORT_SELLING_PRICE",
      depends_on: [this.VIEW_CUSTOMER_ADDITIONAL_EFFORT_SELLING_PRICE],
    }
  },
  get VIEW_CUSTOMER_ADDITIONAL_EFFORT_PRICE() {
    return {
      value: "VIEW_CUSTOMER_ADDITIONAL_EFFORT_PRICE",
    }
  },
  get VIEW_CUSTOMER_USER_HOURLY_PAY() {
    return {
      value: "VIEW_CUSTOMER_USER_HOURLY_PAY",
    }
  },
  get EDIT_CUSTOMER_USER_HOURLY_PAY() {
    return {
      value: "EDIT_CUSTOMER_USER_HOURLY_PAY",
      depends_on: [this.VIEW_CUSTOMER_USER_HOURLY_PAY],
    }
  },

  // User-Position Management
  VIEW_USER_POSITION_GENERAL: {
    value: "VIEW_USER_POSITION_GENERAL",
  },
  get EDIT_USER_POSITION_GENERAL() {
    return {
      value: "EDIT_USER_POSITION_GENERAL",
      depends_on: [this.VIEW_USER_POSITION_GENERAL],
    }
  },
  get DELETE_USER_POSITION_GENERAL() {
    return {
      value: "DELETE_USER_POSITION_GENERAL",
      depends_on: [this.EDIT_USER_POSITION_GENERAL],
    }
  },
  VIEW_USER_POSITION_HOURLY_RATE: {
    value: "VIEW_USER_POSITION_HOURLY_RATE",
  },
  get EDIT_USER_POSITION_HOURLY_RATE() {
    return {
      value: "EDIT_USER_POSITION_HOURLY_RATE",
      depends_on: [this.VIEW_USER_POSITION_HOURLY_RATE],
    }
  },

  // User-Position Management
  VIEW_PACKET_GENERAL: {
    value: "VIEW_PACKET_GENERAL",
  },
  get EDIT_PACKET_GENERAL() {
    return {
      value: "EDIT_PACKET_GENERAL",
      depends_on: [this.VIEW_PACKET_GENERAL],
    }
  },
  get DELETE_PACKET_GENERAL() {
    return {
      value: "DELETE_PACKET_GENERAL",
      depends_on: [this.EDIT_PACKET_GENERAL],
    }
  },

  // Project Management
  // // // Assigned Project
  get VIEW_ASSIGNED_PROJECT_GENERAL() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_GENERAL",
      depends_on: [this.VIEW_CUSTOMER_GENERAL],
    }
  },
  get EDIT_ASSIGNED_PROJECT_GENERAL() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_GENERAL",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_GENERAL],
    }
  },
  get DELETE_ASSIGNED_PROJECT_GENERAL() {
    return {
      value: "DELETE_ASSIGNED_PROJECT_GENERAL",
      depends_on: [this.EDIT_ASSIGNED_PROJECT_GENERAL],
    }
  },
  get VIEW_ASSIGNED_PROJECT_HOURLYWAGEREPORT() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_HOURLYWAGEREPORT",
    }
  },
  get EDIT_ASSIGNED_PROJECT_HOURLYWAGEREPORT() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_HOURLYWAGEREPORT",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_HOURLYWAGEREPORT],
    }
  },
  get DELETE_ASSIGNED_PROJECT_HOURLYWAGEREPORT() {
    return {
      value: "DELETE_ASSIGNED_PROJECT_HOURLYWAGEREPORT",
      depends_on: [this.EDIT_ASSIGNED_PROJECT_HOURLYWAGEREPORT],
    }
  },
  get VIEW_ASSIGNED_PROJECT_CONSTRUCTIONREPORT() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_CONSTRUCTIONREPORT",
    }
  },
  get EDIT_ASSIGNED_PROJECT_CONSTRUCTIONREPORT() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_CONSTRUCTIONREPORT",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_CONSTRUCTIONREPORT],
    }
  },
  get DELETE_ASSIGNED_PROJECT_CONSTRUCTIONREPORT() {
    return {
      value: "DELETE_ASSIGNED_PROJECT_CONSTRUCTIONREPORT",
      depends_on: [this.EDIT_ASSIGNED_PROJECT_CONSTRUCTIONREPORT],
    }
  },
  // Tagesmeldungen: the days the app's users sent to the site management, of these projects. Making a report
  // of one also takes that report's own EDIT right. No DELETE: a Tagesmeldung is dismissed, not deleted.
  get VIEW_ASSIGNED_PROJECT_DAY_SUBMISSION() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_DAY_SUBMISSION",
    }
  },
  get EDIT_ASSIGNED_PROJECT_DAY_SUBMISSION() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_DAY_SUBMISSION",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_DAY_SUBMISSION],
    }
  },
  get VIEW_ASSIGNED_PROJECT_CONTACT() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_CONTACT",
      depends_on: [this.VIEW_CUSTOMER_CONTACT],
    }
  },
  get EDIT_ASSIGNED_PROJECT_CONTACT() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_CONTACT",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_CONTACT, this.EDIT_CUSTOMER_CONTACT],
    }
  },
  get DELETE_ASSIGNED_PROJECT_CONTACT() {
    return {
      value: "DELETE_ASSIGNED_PROJECT_CONTACT",
      depends_on: [this.EDIT_ASSIGNED_PROJECT_CONTACT],
    }
  },
  get VIEW_ASSIGNED_PROJECT_MACHINE() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_MACHINE",
    }
  },
  get EDIT_ASSIGNED_PROJECT_MACHINE() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_MACHINE",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_MACHINE, this.EDIT_CUSTOMER_MACHINE],
    }
  },
  get DELETE_ASSIGNED_PROJECT_MACHINE() {
    return {
      value: "DELETE_ASSIGNED_PROJECT_MACHINE",
      depends_on: [this.EDIT_ASSIGNED_PROJECT_MACHINE],
    }
  },
  get VIEW_ASSIGNED_PROJECT_MATERIAL() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_MATERIAL",
    }
  },
  get EDIT_ASSIGNED_PROJECT_MATERIAL() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_MATERIAL",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_MATERIAL, this.EDIT_CUSTOMER_MATERIAL],
    }
  },
  get DELETE_ASSIGNED_PROJECT_MATERIAL() {
    return {
      value: "DELETE_ASSIGNED_PROJECT_MATERIAL",
      depends_on: [this.EDIT_ASSIGNED_PROJECT_MATERIAL],
    }
  },
  get VIEW_ASSIGNED_PROJECT_ADDITIONAL_EFFORT() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_ADDITIONAL_EFFORT",
    }
  },
  get EDIT_ASSIGNED_PROJECT_ADDITIONAL_EFFORT() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_ADDITIONAL_EFFORT",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_ADDITIONAL_EFFORT, this.EDIT_CUSTOMER_ADDITIONAL_EFFORT],
    }
  },
  get DELETE_ASSIGNED_PROJECT_ADDITIONAL_EFFORT() {
    return {
      value: "DELETE_ASSIGNED_PROJECT_ADDITIONAL_EFFORT",
      depends_on: [this.EDIT_ASSIGNED_PROJECT_ADDITIONAL_EFFORT],
    }
  },
  get VIEW_ASSIGNED_PROJECT_CATEGORY() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_CATEGORY",
      depends_on: [this.VIEW_CATEGORY_GENERAL],
    }
  },
  get EDIT_ASSIGNED_PROJECT_CATEGORY() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_CATEGORY",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_CATEGORY],
    }
  },
  get VIEW_ASSIGNED_PROJECT_USER() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_USER",
      depends_on: [this.VIEW_USER_GENERAL, this.VIEW_ASSIGNED_PROJECT_USERPOSITION],
    }
  },
  get EDIT_ASSIGNED_PROJECT_USER() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_USER",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_USER],
    }
  },
  get DELETE_ASSIGNED_PROJECT_USER() {
    return {
      value: "DELETE_ASSIGNED_PROJECT_USER",
      depends_on: [this.EDIT_ASSIGNED_PROJECT_USER],
    }
  },
  get VIEW_ASSIGNED_PROJECT_USERPOSITION() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_USERPOSITION",
      depends_on: [this.VIEW_USER_POSITION_GENERAL],
    }
  },
  get EDIT_ASSIGNED_PROJECT_USERPOSITION() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_USERPOSITION",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_USERPOSITION],
    }
  },
  get DELETE_ASSIGNED_PROJECT_USERPOSITION() {
    return {
      value: "DELETE_ASSIGNED_PROJECT_USERPOSITION",
      depends_on: [this.EDIT_ASSIGNED_PROJECT_USERPOSITION],
    }
  },
  get VIEW_ASSIGNED_PROJECT_FILE() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_FILE",
    }
  },
  get EDIT_ASSIGNED_PROJECT_FILE() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_FILE",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_FILE],
    }
  },
  get DELETE_ASSIGNED_PROJECT_FILE() {
    return {
      value: "DELETE_ASSIGNED_PROJECT_FILE",
      depends_on: [this.EDIT_ASSIGNED_PROJECT_FILE],
    }
  },
  get VIEW_ASSIGNED_PROJECT_SETTINGS() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_SETTINGS",
    }
  },
  get EDIT_ASSIGNED_PROJECT_SETTINGS() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_SETTINGS",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_SETTINGS],
    }
  },
  get VIEW_ASSIGNED_PROJECT_HOURLYWAGEINVOICE() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_HOURLYWAGEINVOICE",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_HOURLYWAGEREPORT],
    }
  },
  // Leistungskatalog (the offer's positions, Nachträge, progress booked from the Bautagesberichte).
  // Its own triple, deliberately NOT the cost permission: the person who books what was done today is
  // exactly the person *_PROJECT_COSTS is designed to keep out. Prices and every euro figure inside
  // the catalogue stay gated by *_PROJECT_COSTS and are nulled out server-side otherwise.
  get VIEW_ASSIGNED_PROJECT_SERVICE_CATALOG() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_SERVICE_CATALOG",
    }
  },
  get EDIT_ASSIGNED_PROJECT_SERVICE_CATALOG() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_SERVICE_CATALOG",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_SERVICE_CATALOG],
    }
  },
  get DELETE_ASSIGNED_PROJECT_SERVICE_CATALOG() {
    return {
      value: "DELETE_ASSIGNED_PROJECT_SERVICE_CATALOG",
      depends_on: [this.EDIT_ASSIGNED_PROJECT_SERVICE_CATALOG],
    }
  },
  // Running post-calculation (cost timeline, report cost breakdowns, budget). EDIT sets the budget
  // and the plan; there is nothing to delete, so there is no DELETE.
  get VIEW_ASSIGNED_PROJECT_COSTS() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_COSTS",
      depends_on: [
        this.VIEW_ASSIGNED_PROJECT_HOURLYWAGEREPORT,
        this.VIEW_ASSIGNED_PROJECT_CONSTRUCTIONREPORT,
        // The Nachkalkulation renders the montage rollup, so a cost holder must be able to see it.
        this.VIEW_ASSIGNED_PROJECT_SERVICE_CATALOG,
      ],
    }
  },
  get EDIT_ASSIGNED_PROJECT_COSTS() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_COSTS",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_COSTS],
    }
  },
  // Project phases (timeline phases with capacities), editable from the project detail view and
  // the personnel-planning gantt.
  get VIEW_ASSIGNED_PROJECT_PHASE() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_PHASE",
    }
  },
  get EDIT_ASSIGNED_PROJECT_PHASE() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_PHASE",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_PHASE],
    }
  },
  get DELETE_ASSIGNED_PROJECT_PHASE() {
    return {
      value: "DELETE_ASSIGNED_PROJECT_PHASE",
      depends_on: [this.EDIT_ASSIGNED_PROJECT_PHASE],
    }
  },

  get VIEW_ASSIGNED_PROJECT_MACHINE_PURCHASEPRICE() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_MACHINE_PURCHASEPRICE",
    }
  },
  get EDIT_ASSIGNED_PROJECT_MACHINE_PURCHASEPRICE() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_MACHINE_PURCHASEPRICE",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_MACHINE_PURCHASEPRICE],
    }
  },
  get VIEW_ASSIGNED_PROJECT_MACHINE_SELLINGPRICE() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_MACHINE_SELLINGPRICE",
    }
  },
  get EDIT_ASSIGNED_PROJECT_MACHINE_SELLINGPRICE() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_MACHINE_SELLINGPRICE",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_MACHINE_SELLINGPRICE],
    }
  },
  get VIEW_ASSIGNED_PROJECT_MATERIAL_PURCHASEPRICE() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_MATERIAL_PURCHASEPRICE",
    }
  },
  get EDIT_ASSIGNED_PROJECT_MATERIAL_PURCHASEPRICE() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_MATERIAL_PURCHASEPRICE",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_MATERIAL_PURCHASEPRICE],
    }
  },
  get VIEW_ASSIGNED_PROJECT_MATERIAL_SELLINGPRICE() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_MATERIAL_SELLINGPRICE",
    }
  },
  get EDIT_ASSIGNED_PROJECT_MATERIAL_SELLINGPRICE() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_MATERIAL_SELLINGPRICE",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_MATERIAL_SELLINGPRICE],
    }
  },
  get VIEW_ASSIGNED_PROJECT_ADDITIONAL_EFFORT_PRICE() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_ADDITIONAL_EFFORT_PRICE",
    }
  },
  get VIEW_ASSIGNED_PROJECT_ADDITIONAL_EFFORT_SELLINGPRICE() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_ADDITIONAL_EFFORT_SELLINGPRICE",
    }
  },
  get EDIT_ASSIGNED_PROJECT_ADDITIONAL_EFFORT_SELLINGPRICE() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_ADDITIONAL_EFFORT_SELLINGPRICE",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_ADDITIONAL_EFFORT_SELLINGPRICE],
    }
  },
  get VIEW_ASSIGNED_PROJECT_USERPOSITION_HOURLYPAY() {
    return {
      value: "VIEW_ASSIGNED_PROJECT_USERPOSITION_HOURLYPAY",
    }
  },
  get EDIT_ASSIGNED_PROJECT_USERPOSITION_HOURLYPAY() {
    return {
      value: "EDIT_ASSIGNED_PROJECT_USERPOSITION_HOURLYPAY",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_USERPOSITION_HOURLYPAY],
    }
  },

  // // // Foreign Project
  get VIEW_FOREIGN_PROJECT_GENERAL() {
    return {
      value: "VIEW_FOREIGN_PROJECT_GENERAL",
      depends_on: [this.VIEW_CUSTOMER_GENERAL],
    }
  },
  get EDIT_FOREIGN_PROJECT_GENERAL() {
    return {
      value: "EDIT_FOREIGN_PROJECT_GENERAL",
      depends_on: [this.VIEW_FOREIGN_PROJECT_GENERAL],
    }
  },
  get DELETE_FOREIGN_PROJECT_GENERAL() {
    return {
      value: "DELETE_FOREIGN_PROJECT_GENERAL",
      depends_on: [this.EDIT_FOREIGN_PROJECT_GENERAL],
    }
  },
  get VIEW_FOREIGN_PROJECT_HOURLYWAGEREPORT() {
    return {
      value: "VIEW_FOREIGN_PROJECT_HOURLYWAGEREPORT",
    }
  },
  get EDIT_FOREIGN_PROJECT_HOURLYWAGEREPORT() {
    return {
      value: "EDIT_FOREIGN_PROJECT_HOURLYWAGEREPORT",
      depends_on: [this.VIEW_FOREIGN_PROJECT_HOURLYWAGEREPORT],
    }
  },
  get DELETE_FOREIGN_PROJECT_HOURLYWAGEREPORT() {
    return {
      value: "DELETE_FOREIGN_PROJECT_HOURLYWAGEREPORT",
      depends_on: [this.EDIT_FOREIGN_PROJECT_HOURLYWAGEREPORT],
    }
  },
  get VIEW_FOREIGN_PROJECT_CONSTRUCTIONREPORT() {
    return {
      value: "VIEW_FOREIGN_PROJECT_CONSTRUCTIONREPORT",
    }
  },
  get EDIT_FOREIGN_PROJECT_CONSTRUCTIONREPORT() {
    return {
      value: "EDIT_FOREIGN_PROJECT_CONSTRUCTIONREPORT",
      depends_on: [this.VIEW_FOREIGN_PROJECT_CONSTRUCTIONREPORT],
    }
  },
  get DELETE_FOREIGN_PROJECT_CONSTRUCTIONREPORT() {
    return {
      value: "DELETE_FOREIGN_PROJECT_CONSTRUCTIONREPORT",
      depends_on: [this.EDIT_FOREIGN_PROJECT_CONSTRUCTIONREPORT],
    }
  },
  // Tagesmeldungen: the days the app's users sent to the site management, of these projects. Making a report
  // of one also takes that report's own EDIT right. No DELETE: a Tagesmeldung is dismissed, not deleted.
  get VIEW_FOREIGN_PROJECT_DAY_SUBMISSION() {
    return {
      value: "VIEW_FOREIGN_PROJECT_DAY_SUBMISSION",
    }
  },
  get EDIT_FOREIGN_PROJECT_DAY_SUBMISSION() {
    return {
      value: "EDIT_FOREIGN_PROJECT_DAY_SUBMISSION",
      depends_on: [this.VIEW_FOREIGN_PROJECT_DAY_SUBMISSION],
    }
  },
  get VIEW_FOREIGN_PROJECT_CONTACT() {
    return {
      value: "VIEW_FOREIGN_PROJECT_CONTACT",
      depends_on: [this.VIEW_CUSTOMER_CONTACT],
    }
  },
  get EDIT_FOREIGN_PROJECT_CONTACT() {
    return {
      value: "EDIT_FOREIGN_PROJECT_CONTACT",
      depends_on: [this.VIEW_FOREIGN_PROJECT_CONTACT, this.EDIT_CUSTOMER_CONTACT],
    }
  },
  get DELETE_FOREIGN_PROJECT_CONTACT() {
    return {
      value: "DELETE_FOREIGN_PROJECT_CONTACT",
      depends_on: [this.EDIT_FOREIGN_PROJECT_CONTACT],
    }
  },
  get VIEW_FOREIGN_PROJECT_MACHINE() {
    return {
      value: "VIEW_FOREIGN_PROJECT_MACHINE",
    }
  },
  get EDIT_FOREIGN_PROJECT_MACHINE() {
    return {
      value: "EDIT_FOREIGN_PROJECT_MACHINE",
      depends_on: [this.VIEW_FOREIGN_PROJECT_MACHINE, this.EDIT_CUSTOMER_MACHINE],
    }
  },
  get DELETE_FOREIGN_PROJECT_MACHINE() {
    return {
      value: "DELETE_FOREIGN_PROJECT_MACHINE",
      depends_on: [this.EDIT_FOREIGN_PROJECT_MACHINE],
    }
  },
  get VIEW_FOREIGN_PROJECT_MATERIAL() {
    return {
      value: "VIEW_FOREIGN_PROJECT_MATERIAL",
    }
  },
  get EDIT_FOREIGN_PROJECT_MATERIAL() {
    return {
      value: "EDIT_FOREIGN_PROJECT_MATERIAL",
      depends_on: [this.VIEW_FOREIGN_PROJECT_MATERIAL, this.EDIT_CUSTOMER_MATERIAL],
    }
  },
  get DELETE_FOREIGN_PROJECT_MATERIAL() {
    return {
      value: "DELETE_FOREIGN_PROJECT_MATERIAL",
      depends_on: [this.EDIT_FOREIGN_PROJECT_MATERIAL],
    }
  },
  get VIEW_FOREIGN_PROJECT_ADDITIONAL_EFFORT() {
    return {
      value: "VIEW_FOREIGN_PROJECT_ADDITIONAL_EFFORT",
    }
  },
  get EDIT_FOREIGN_PROJECT_ADDITIONAL_EFFORT() {
    return {
      value: "EDIT_FOREIGN_PROJECT_ADDITIONAL_EFFORT",
      depends_on: [this.VIEW_FOREIGN_PROJECT_ADDITIONAL_EFFORT, this.EDIT_CUSTOMER_ADDITIONAL_EFFORT],
    }
  },
  get DELETE_FOREIGN_PROJECT_ADDITIONAL_EFFORT() {
    return {
      value: "DELETE_FOREIGN_PROJECT_ADDITIONAL_EFFORT",
      depends_on: [this.EDIT_FOREIGN_PROJECT_ADDITIONAL_EFFORT],
    }
  },
  get VIEW_FOREIGN_PROJECT_CATEGORY() {
    return {
      value: "VIEW_FOREIGN_PROJECT_CATEGORY",
      depends_on: [this.VIEW_CATEGORY_GENERAL],
    }
  },
  get EDIT_FOREIGN_PROJECT_CATEGORY() {
    return {
      value: "EDIT_FOREIGN_PROJECT_CATEGORY",
      depends_on: [this.VIEW_FOREIGN_PROJECT_CATEGORY],
    }
  },
  get VIEW_FOREIGN_PROJECT_USER() {
    return {
      value: "VIEW_FOREIGN_PROJECT_USER",
      depends_on: [this.VIEW_USER_GENERAL, this.VIEW_FOREIGN_PROJECT_USERPOSITION],
    }
  },
  get EDIT_FOREIGN_PROJECT_USER() {
    return {
      value: "EDIT_FOREIGN_PROJECT_USER",
      depends_on: [this.VIEW_FOREIGN_PROJECT_USER],
    }
  },
  get DELETE_FOREIGN_PROJECT_USER() {
    return {
      value: "DELETE_FOREIGN_PROJECT_USER",
      depends_on: [this.EDIT_FOREIGN_PROJECT_USER],
    }
  },
  get VIEW_FOREIGN_PROJECT_USERPOSITION() {
    return {
      value: "VIEW_FOREIGN_PROJECT_USERPOSITION",
      depends_on: [this.VIEW_USER_POSITION_GENERAL],
    }
  },
  get EDIT_FOREIGN_PROJECT_USERPOSITION() {
    return {
      value: "EDIT_FOREIGN_PROJECT_USERPOSITION",
      depends_on: [this.VIEW_FOREIGN_PROJECT_USERPOSITION],
    }
  },
  get DELETE_FOREIGN_PROJECT_USERPOSITION() {
    return {
      value: "DELETE_FOREIGN_PROJECT_USERPOSITION",
      depends_on: [this.EDIT_FOREIGN_PROJECT_USERPOSITION],
    }
  },
  get VIEW_FOREIGN_PROJECT_FILE() {
    return {
      value: "VIEW_FOREIGN_PROJECT_FILE",
    }
  },
  get EDIT_FOREIGN_PROJECT_FILE() {
    return {
      value: "EDIT_FOREIGN_PROJECT_FILE",
      depends_on: [this.VIEW_FOREIGN_PROJECT_FILE],
    }
  },
  get DELETE_FOREIGN_PROJECT_FILE() {
    return {
      value: "DELETE_FOREIGN_PROJECT_FILE",
      depends_on: [this.EDIT_FOREIGN_PROJECT_FILE],
    }
  },
  get VIEW_FOREIGN_PROJECT_SETTINGS() {
    return {
      value: "VIEW_FOREIGN_PROJECT_SETTINGS",
    }
  },
  get EDIT_FOREIGN_PROJECT_SETTINGS() {
    return {
      value: "EDIT_FOREIGN_PROJECT_SETTINGS",
      depends_on: [this.VIEW_FOREIGN_PROJECT_SETTINGS],
    }
  },
  get VIEW_FOREIGN_PROJECT_HOURLYWAGEINVOICE() {
    return {
      value: "VIEW_FOREIGN_PROJECT_HOURLYWAGEINVOICE",
      depends_on: [this.VIEW_FOREIGN_PROJECT_HOURLYWAGEREPORT],
    }
  },
  // Montage tracking — see the assigned-project section for the permission/money split.
  get VIEW_FOREIGN_PROJECT_SERVICE_CATALOG() {
    return {
      value: "VIEW_FOREIGN_PROJECT_SERVICE_CATALOG",
    }
  },
  get EDIT_FOREIGN_PROJECT_SERVICE_CATALOG() {
    return {
      value: "EDIT_FOREIGN_PROJECT_SERVICE_CATALOG",
      depends_on: [this.VIEW_FOREIGN_PROJECT_SERVICE_CATALOG],
    }
  },
  get DELETE_FOREIGN_PROJECT_SERVICE_CATALOG() {
    return {
      value: "DELETE_FOREIGN_PROJECT_SERVICE_CATALOG",
      depends_on: [this.EDIT_FOREIGN_PROJECT_SERVICE_CATALOG],
    }
  },
  // Running post-calculation — see the assigned-project section.
  get VIEW_FOREIGN_PROJECT_COSTS() {
    return {
      value: "VIEW_FOREIGN_PROJECT_COSTS",
      depends_on: [this.VIEW_FOREIGN_PROJECT_HOURLYWAGEREPORT, this.VIEW_FOREIGN_PROJECT_CONSTRUCTIONREPORT],
    }
  },
  get EDIT_FOREIGN_PROJECT_COSTS() {
    return {
      value: "EDIT_FOREIGN_PROJECT_COSTS",
      depends_on: [this.VIEW_FOREIGN_PROJECT_COSTS],
    }
  },
  // Project phases — see the assigned-project section.
  get VIEW_FOREIGN_PROJECT_PHASE() {
    return {
      value: "VIEW_FOREIGN_PROJECT_PHASE",
    }
  },
  get EDIT_FOREIGN_PROJECT_PHASE() {
    return {
      value: "EDIT_FOREIGN_PROJECT_PHASE",
      depends_on: [this.VIEW_FOREIGN_PROJECT_PHASE],
    }
  },
  get DELETE_FOREIGN_PROJECT_PHASE() {
    return {
      value: "DELETE_FOREIGN_PROJECT_PHASE",
      depends_on: [this.EDIT_FOREIGN_PROJECT_PHASE],
    }
  },

  // Personalplanung (personnel planning). The planning gantt renders project phases and assigns
  // employees to them, so viewing it requires phase visibility on assigned and foreign projects.
  get VIEW_PERSONNELPLANNING() {
    return {
      value: "VIEW_PERSONNELPLANNING",
      depends_on: [this.VIEW_ASSIGNED_PROJECT_PHASE, this.VIEW_FOREIGN_PROJECT_PHASE],
    }
  },
  get EDIT_PERSONNELPLANNING() {
    return {
      value: "EDIT_PERSONNELPLANNING",
      depends_on: [this.VIEW_PERSONNELPLANNING],
    }
  },
  get DELETE_PERSONNELPLANNING() {
    return {
      value: "DELETE_PERSONNELPLANNING",
      depends_on: [this.EDIT_PERSONNELPLANNING],
    }
  },

  // Arbeitszeitmodelle (working-time models). Master data at the same desk as the Personalrollen —
  // how long a week is, rather than what an hour costs.
  get VIEW_WORK_TIME_MODEL() {
    return {
      value: "VIEW_WORK_TIME_MODEL",
      depends_on: [this.VIEW_USER_POSITION_GENERAL],
    }
  },
  get EDIT_WORK_TIME_MODEL() {
    return {
      value: "EDIT_WORK_TIME_MODEL",
      depends_on: [this.VIEW_WORK_TIME_MODEL],
    }
  },
  get DELETE_WORK_TIME_MODEL() {
    return {
      value: "DELETE_WORK_TIME_MODEL",
      depends_on: [this.EDIT_WORK_TIME_MODEL],
    }
  },

  // Zeiterfassung (time tracking), your own day. RECORD_OWN_TIME opens "Meine Zeiten" and every
  // `/time-tracking/me/**` route; every role holds it by default (predefined roles and migration
  // _038), so the feature still works for the whole staff — the permission exists so that a role
  // *can* be kept out of it. The two BOOK_ rights say which projects a day may be booked to, split
  // like every project right into assigned and foreign: both is every project, one is that side,
  // neither is days without a project only.
  get RECORD_OWN_TIME() {
    return {
      value: "RECORD_OWN_TIME",
    }
  },
  get BOOK_OWN_TIME_ASSIGNED_PROJECT() {
    return {
      value: "BOOK_OWN_TIME_ASSIGNED_PROJECT",
      depends_on: [this.RECORD_OWN_TIME],
    }
  },
  get BOOK_OWN_TIME_FOREIGN_PROJECT() {
    return {
      value: "BOOK_OWN_TIME_FOREIGN_PROJECT",
      depends_on: [this.RECORD_OWN_TIME],
    }
  },

  // Booking to *foreign* projects is not in [DEFAULT_NEW_ROLE_PERMISSIONS] and is not seeded on the
  // predefined roles: `/time-tracking/me/projects` answers with project *names*, so granting it by
  // default would show every site in the workspace to staff who may not open the project list.

  // Zeiterfassung, *somebody else's* recorded time.
  get VIEW_TIME_ENTRY_FOREIGN() {
    return {
      value: "VIEW_TIME_ENTRY_FOREIGN",
      depends_on: [this.VIEW_USER_GENERAL],
    }
  },
  get EDIT_TIME_ENTRY_FOREIGN() {
    return {
      value: "EDIT_TIME_ENTRY_FOREIGN",
      depends_on: [this.VIEW_TIME_ENTRY_FOREIGN],
    }
  },
  get DELETE_TIME_ENTRY_FOREIGN() {
    return {
      value: "DELETE_TIME_ENTRY_FOREIGN",
      depends_on: [this.EDIT_TIME_ENTRY_FOREIGN],
    }
  },
  get APPROVE_TIME_ENTRY() {
    return {
      value: "APPROVE_TIME_ENTRY",
      depends_on: [this.VIEW_TIME_ENTRY_FOREIGN],
    }
  },
  // Approving, rejecting or reopening time one recorded oneself — one's own days and the crew days one
  // typed. Without it the backend refuses those (TIME_ENTRY_SELF_REVIEW), so "somebody else checked it"
  // cannot be skipped; it exists for the workspace whose only approver would otherwise be stuck. No
  // migration grants it to existing roles, and it is not in DEFAULT_NEW_ROLE_PERMISSIONS.
  get APPROVE_OWN_TIME_ENTRY() {
    return {
      value: "APPROVE_OWN_TIME_ENTRY",
      depends_on: [this.APPROVE_TIME_ENTRY],
    }
  },

  // Billing. Backed by FrontendBillingController: VIEW_BILLING guards reading the catalog and the
  // subscription, MANAGE_BILLING every mutation (subscribe, change plan, cancel, payment method).
  get VIEW_BILLING() {
    return {
      value: "VIEW_BILLING",
    }
  },
  get MANAGE_BILLING() {
    return {
      value: "MANAGE_BILLING",
      depends_on: [this.VIEW_BILLING],
    }
  },

  // The full tenant data export (AGB 7.2). Deliberately absent from GROUPED_PERMISSIONS, so it never
  // appears in the role editor: the archive contains every permission-gated field this application has
  // — wages, purchase prices, foreign projects — so there is no version of it that could be safely
  // handed to a narrower role, and the backend only ever grants it to Administrator, which holds every
  // permission by definition rather than by what is stored.
  get EXPORT_TENANT_DATA() {
    return {
      value: "EXPORT_TENANT_DATA",
    }
  },

  // Creating, changing and deleting roles (POST/PUT/DELETE /role). Administrator-only like
  // EXPORT_TENANT_DATA and absent from GROUPED_PERMISSIONS for a similar reason: whoever may edit roles
  // can hand their own role every other right, so it is not a tick to give out. Reading the roles
  // stays open, since the default-role picker and an employee's role assignment need their names.
  get EDIT_ROLES() {
    return {
      value: "EDIT_ROLES",
    }
  },

  get VIEW_FOREIGN_PROJECT_MACHINE_PURCHASEPRICE() {
    return {
      value: "VIEW_FOREIGN_PROJECT_MACHINE_PURCHASEPRICE",
    }
  },
  get EDIT_FOREIGN_PROJECT_MACHINE_PURCHASEPRICE() {
    return {
      value: "EDIT_FOREIGN_PROJECT_MACHINE_PURCHASEPRICE",
      depends_on: [this.VIEW_FOREIGN_PROJECT_MACHINE_PURCHASEPRICE],
    }
  },
  get VIEW_FOREIGN_PROJECT_MACHINE_SELLINGPRICE() {
    return {
      value: "VIEW_FOREIGN_PROJECT_MACHINE_SELLINGPRICE",
    }
  },
  get EDIT_FOREIGN_PROJECT_MACHINE_SELLINGPRICE() {
    return {
      value: "EDIT_FOREIGN_PROJECT_MACHINE_SELLINGPRICE",
      depends_on: [this.VIEW_FOREIGN_PROJECT_MACHINE_SELLINGPRICE],
    }
  },
  get VIEW_FOREIGN_PROJECT_MATERIAL_PURCHASEPRICE() {
    return {
      value: "VIEW_FOREIGN_PROJECT_MATERIAL_PURCHASEPRICE",
    }
  },
  get EDIT_FOREIGN_PROJECT_MATERIAL_PURCHASEPRICE() {
    return {
      value: "EDIT_FOREIGN_PROJECT_MATERIAL_PURCHASEPRICE",
      depends_on: [this.VIEW_FOREIGN_PROJECT_MATERIAL_PURCHASEPRICE],
    }
  },
  get VIEW_FOREIGN_PROJECT_MATERIAL_SELLINGPRICE() {
    return {
      value: "VIEW_FOREIGN_PROJECT_MATERIAL_SELLINGPRICE",
    }
  },
  get EDIT_FOREIGN_PROJECT_MATERIAL_SELLINGPRICE() {
    return {
      value: "EDIT_FOREIGN_PROJECT_MATERIAL_SELLINGPRICE",
      depends_on: [this.VIEW_FOREIGN_PROJECT_MATERIAL_SELLINGPRICE],
    }
  },
  get VIEW_FOREIGN_PROJECT_ADDITIONAL_EFFORT_PRICE() {
    return {
      value: "VIEW_FOREIGN_PROJECT_ADDITIONAL_EFFORT_PRICE",
    }
  },
  get VIEW_FOREIGN_PROJECT_ADDITIONAL_EFFORT_SELLINGPRICE() {
    return {
      value: "VIEW_FOREIGN_PROJECT_ADDITIONAL_EFFORT_SELLINGPRICE",
    }
  },
  get EDIT_FOREIGN_PROJECT_ADDITIONAL_EFFORT_SELLINGPRICE() {
    return {
      value: "EDIT_FOREIGN_PROJECT_ADDITIONAL_EFFORT_SELLINGPRICE",
      depends_on: [this.VIEW_FOREIGN_PROJECT_ADDITIONAL_EFFORT_SELLINGPRICE],
    }
  },
  get VIEW_FOREIGN_PROJECT_USERPOSITION_HOURLYPAY() {
    return {
      value: "VIEW_FOREIGN_PROJECT_USERPOSITION_HOURLYPAY",
    }
  },
  get EDIT_FOREIGN_PROJECT_USERPOSITION_HOURLYPAY() {
    return {
      value: "EDIT_FOREIGN_PROJECT_USERPOSITION_HOURLYPAY",
      depends_on: [this.VIEW_FOREIGN_PROJECT_USERPOSITION_HOURLYPAY],
    }
  },
}

/**
 * What a role created in Settings starts with — the rights every role the product itself creates holds
 * (`PredefinedRole` and backend migration `_038`).
 *
 * A role built without them would be the only one whose users have no "Meine Zeiten", which is a
 * Zeiterfassung that quietly stops working for one department. Ordinary ticks: untick them for a role
 * that should not record time. Booking to foreign projects is deliberately not here — see the note
 * beside the permissions themselves.
 */
export const DEFAULT_NEW_ROLE_PERMISSIONS = [PERMISSIONS.RECORD_OWN_TIME, PERMISSIONS.BOOK_OWN_TIME_ASSIGNED_PROJECT]

// The names are German display text. Report names are written as term tokens (`[[hwr.pl]]`) so the
// role editor shows the workspace's own word; LewRightParentAssignment resolves them.
export const GROUPED_PERMISSIONS = [
  {
    name: "Mitarbeiterübersicht",
    children: [
      {
        name: "Allgemein",
        show: PERMISSIONS.VIEW_USER_GENERAL,
        edit: PERMISSIONS.EDIT_USER_GENERAL,
        delete: PERMISSIONS.DELETE_USER_GENERAL,
      },
      {
        name: "Unternehmens Relevant",
        children: [
          {
            name: "Allgemein",
            show: PERMISSIONS.VIEW_USER_COMPANY_GENERAL,
            edit: PERMISSIONS.EDIT_USER_COMPANY_GENERAL,
          },
          {
            name: "Urlaubstage",
            show: PERMISSIONS.VIEW_USER_COMPANY_TOTAL_HOLIDAY_DAYS,
            edit: PERMISSIONS.EDIT_USER_COMPANY_TOTAL_HOLIDAY_DAYS,
          },
          {
            name: "Sozialversicherungsnummer",
            show: PERMISSIONS.VIEW_USER_COMPANY_SOCIAL_INSURANCE_NUMBER,
            edit: PERMISSIONS.EDIT_USER_COMPANY_SOCIAL_INSURANCE_NUMBER,
          },
          {
            name: "Sozialversicherung",
            show: PERMISSIONS.VIEW_USER_COMPANY_SOCIAL_INSURANCE,
            edit: PERMISSIONS.EDIT_USER_COMPANY_SOCIAL_INSURANCE,
          },
        ],
      },
      {
        name: "System Spezifisch",
        show: PERMISSIONS.VIEW_USER_SYSTEM,
        edit: PERMISSIONS.EDIT_USER_SYSTEM,
      },
      {
        name: "Dateiablage",
        show: PERMISSIONS.VIEW_USER_FILE,
        edit: PERMISSIONS.EDIT_USER_FILE,
        delete: PERMISSIONS.DELETE_USER_FILE,
      },
      {
        name: "Erweitert",
        show: PERMISSIONS.VIEW_USER_EXTENDED,
        edit: PERMISSIONS.EDIT_USER_EXTENDED,
      },
    ],
  },
  {
    name: "Kategorienübersicht",
    children: [
      {
        name: "Allgemein",
        show: PERMISSIONS.VIEW_CATEGORY_GENERAL,
        edit: PERMISSIONS.EDIT_CATEGORY_GENERAL,
        delete: PERMISSIONS.DELETE_CATEGORY_GENERAL,
      },
    ],
  },
  {
    name: "Maschinenübersicht",
    children: [
      {
        name: "Allgemein",
        show: PERMISSIONS.VIEW_MACHINE_GENERAL,
        edit: PERMISSIONS.EDIT_MACHINE_GENERAL,
        delete: PERMISSIONS.DELETE_MACHINE_GENERAL,
      },
    ],
  },
  {
    name: "Lieferantenübersicht",
    children: [
      {
        name: "Allgemein",
        show: PERMISSIONS.VIEW_SUPPLIER_GENERAL,
        edit: PERMISSIONS.EDIT_SUPPLIER_GENERAL,
        delete: PERMISSIONS.DELETE_SUPPLIER_GENERAL,
      },
    ],
  },
  {
    name: "Materialübersicht",
    children: [
      {
        name: "Allgemein",
        show: PERMISSIONS.VIEW_MATERIAL_GENERAL,
        edit: PERMISSIONS.EDIT_MATERIAL_GENERAL,
        delete: PERMISSIONS.DELETE_MATERIAL_GENERAL,
      },
    ],
  },
  {
    name: "Zusätzliche Leistungs-Übersicht",
    children: [
      {
        name: "Allgemein",
        show: PERMISSIONS.VIEW_ADDITIONAL_EFFORT_GENERAL,
        edit: PERMISSIONS.EDIT_ADDITIONAL_EFFORT_GENERAL,
        delete: PERMISSIONS.DELETE_ADDITIONAL_EFFORT_GENERAL,
      },
    ],
  },
  {
    name: "Kundenübersicht",
    children: [
      {
        name: "Allgemein",
        show: PERMISSIONS.VIEW_CUSTOMER_GENERAL,
        edit: PERMISSIONS.EDIT_CUSTOMER_GENERAL,
        delete: PERMISSIONS.DELETE_CUSTOMER_GENERAL,
      },
      {
        name: "Ansprechpartner",
        show: PERMISSIONS.VIEW_CUSTOMER_CONTACT,
        edit: PERMISSIONS.EDIT_CUSTOMER_CONTACT,
        delete: PERMISSIONS.DELETE_CUSTOMER_CONTACT,
      },
      {
        name: "Maschinen",
        show: PERMISSIONS.VIEW_CUSTOMER_MACHINE,
        edit: PERMISSIONS.EDIT_CUSTOMER_MACHINE,
        delete: PERMISSIONS.DELETE_CUSTOMER_MACHINE,
      },
      {
        name: "Materialien",
        show: PERMISSIONS.VIEW_CUSTOMER_MATERIAL,
        edit: PERMISSIONS.EDIT_CUSTOMER_MATERIAL,
        delete: PERMISSIONS.DELETE_CUSTOMER_MATERIAL,
      },
      {
        name: "Zusätzliche Aufwände",
        show: PERMISSIONS.VIEW_CUSTOMER_ADDITIONAL_EFFORT,
        edit: PERMISSIONS.EDIT_CUSTOMER_ADDITIONAL_EFFORT,
        delete: PERMISSIONS.DELETE_CUSTOMER_ADDITIONAL_EFFORT,
      },
      {
        name: "Dateiablage",
        show: PERMISSIONS.VIEW_CUSTOMER_FILE,
        edit: PERMISSIONS.EDIT_CUSTOMER_FILE,
        delete: PERMISSIONS.DELETE_CUSTOMER_FILE,
      },
      {
        name: "Personalrollen",
        show: PERMISSIONS.VIEW_CUSTOMER_USERPOSITION,
        edit: PERMISSIONS.EDIT_CUSTOMER_USERPOSITION,
        delete: PERMISSIONS.DELETE_CUSTOMER_USERPOSITION,
      },
      {
        name: "Einstelllungen",
        show: PERMISSIONS.VIEW_CUSTOMER_SETTINGS,
        edit: PERMISSIONS.EDIT_CUSTOMER_SETTINGS,
      },
    ],
  },
  {
    name: "Personalrollen Übersicht",
    children: [
      {
        name: "Allgemein",
        show: PERMISSIONS.VIEW_USER_POSITION_GENERAL,
        edit: PERMISSIONS.EDIT_USER_POSITION_GENERAL,
        delete: PERMISSIONS.DELETE_USER_POSITION_GENERAL,
      },
    ],
  },
  {
    name: "Paket Übersicht",
    children: [
      {
        name: "Allgemein",
        show: PERMISSIONS.VIEW_PACKET_GENERAL,
        edit: PERMISSIONS.EDIT_PACKET_GENERAL,
        delete: PERMISSIONS.DELETE_PACKET_GENERAL,
      },
    ],
  },
  {
    name: "Eigene Projekte + Abrechnung",
    children: [
      {
        name: "Allgemein",
        show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_GENERAL,
        edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_GENERAL,
        delete: PERMISSIONS.DELETE_ASSIGNED_PROJECT_GENERAL,
      },
      {
        name: "[[hwr.pl]]",
        show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_HOURLYWAGEREPORT,
        edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_HOURLYWAGEREPORT,
        delete: PERMISSIONS.DELETE_ASSIGNED_PROJECT_HOURLYWAGEREPORT,
      },
      {
        name: "Ansprechpartner",
        show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_CONTACT,
        edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_CONTACT,
        delete: PERMISSIONS.DELETE_ASSIGNED_PROJECT_CONTACT,
      },
      {
        name: "[[cr.pl]]",
        show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_CONSTRUCTIONREPORT,
        edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_CONSTRUCTIONREPORT,
        delete: PERMISSIONS.DELETE_ASSIGNED_PROJECT_CONSTRUCTIONREPORT,
      },
      {
        name: "Tagesmeldungen",
        show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_DAY_SUBMISSION,
        edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_DAY_SUBMISSION,
      },
      {
        name: "Maschinen",
        show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_MACHINE,
        edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_MACHINE,
        delete: PERMISSIONS.DELETE_ASSIGNED_PROJECT_MACHINE,
      },
      {
        name: "Materialien",
        show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_MATERIAL,
        edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_MATERIAL,
        delete: PERMISSIONS.DELETE_ASSIGNED_PROJECT_MATERIAL,
      },
      {
        name: "Zusätzliche Aufwände",
        show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_ADDITIONAL_EFFORT,
        edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_ADDITIONAL_EFFORT,
        delete: PERMISSIONS.DELETE_ASSIGNED_PROJECT_ADDITIONAL_EFFORT,
      },
      {
        name: "Kategorien",
        show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_CATEGORY,
        edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_CATEGORY,
      },
      {
        name: "Personal",
        show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_USER,
        edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_USER,
        delete: PERMISSIONS.DELETE_ASSIGNED_PROJECT_USER,
      },
      {
        name: "Personalrollen",
        show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_USERPOSITION,
        edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_USERPOSITION,
        delete: PERMISSIONS.DELETE_ASSIGNED_PROJECT_USERPOSITION,
      },
      {
        name: "Dateiablage",
        show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_FILE,
        edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_FILE,
        delete: PERMISSIONS.DELETE_ASSIGNED_PROJECT_FILE,
      },
      {
        name: "Konfiguration",
        show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_SETTINGS,
        edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_SETTINGS,
      },
      {
        name: "Abrechnen",
        show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_HOURLYWAGEINVOICE,
      },
      {
        name: "Nachkalkulation",
        show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_COSTS,
        edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_COSTS,
      },
      {
        name: "Leistungskatalog",
        show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_SERVICE_CATALOG,
        edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_SERVICE_CATALOG,
        delete: PERMISSIONS.DELETE_ASSIGNED_PROJECT_SERVICE_CATALOG,
      },
      {
        name: "Projektphasen",
        show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_PHASE,
        edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_PHASE,
        delete: PERMISSIONS.DELETE_ASSIGNED_PROJECT_PHASE,
      },
    ],
  },
  {
    name: "Fremde Projekte + Abrechnung",
    children: [
      {
        name: "Allgemein",
        show: PERMISSIONS.VIEW_FOREIGN_PROJECT_GENERAL,
        edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_GENERAL,
        delete: PERMISSIONS.DELETE_FOREIGN_PROJECT_GENERAL,
      },
      {
        name: "[[hwr.pl]]",
        show: PERMISSIONS.VIEW_FOREIGN_PROJECT_HOURLYWAGEREPORT,
        edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_HOURLYWAGEREPORT,
        delete: PERMISSIONS.DELETE_FOREIGN_PROJECT_HOURLYWAGEREPORT,
      },
      {
        name: "Ansprechpartner",
        show: PERMISSIONS.VIEW_FOREIGN_PROJECT_CONTACT,
        edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_CONTACT,
        delete: PERMISSIONS.DELETE_FOREIGN_PROJECT_CONTACT,
      },
      {
        name: "[[cr.pl]]",
        show: PERMISSIONS.VIEW_FOREIGN_PROJECT_CONSTRUCTIONREPORT,
        edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_CONSTRUCTIONREPORT,
        delete: PERMISSIONS.DELETE_FOREIGN_PROJECT_CONSTRUCTIONREPORT,
      },
      {
        name: "Tagesmeldungen",
        show: PERMISSIONS.VIEW_FOREIGN_PROJECT_DAY_SUBMISSION,
        edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_DAY_SUBMISSION,
      },
      {
        name: "Maschinen",
        show: PERMISSIONS.VIEW_FOREIGN_PROJECT_MACHINE,
        edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_MACHINE,
        delete: PERMISSIONS.DELETE_FOREIGN_PROJECT_MACHINE,
      },
      {
        name: "Materialien",
        show: PERMISSIONS.VIEW_FOREIGN_PROJECT_MATERIAL,
        edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_MATERIAL,
        delete: PERMISSIONS.DELETE_FOREIGN_PROJECT_MATERIAL,
      },
      {
        name: "Zusätzliche Aufwände",
        show: PERMISSIONS.VIEW_FOREIGN_PROJECT_ADDITIONAL_EFFORT,
        edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_ADDITIONAL_EFFORT,
        delete: PERMISSIONS.DELETE_FOREIGN_PROJECT_ADDITIONAL_EFFORT,
      },
      {
        name: "Kategorien",
        show: PERMISSIONS.VIEW_FOREIGN_PROJECT_CATEGORY,
        edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_CATEGORY,
      },
      {
        name: "Personal",
        show: PERMISSIONS.VIEW_FOREIGN_PROJECT_USER,
        edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_USER,
        delete: PERMISSIONS.DELETE_FOREIGN_PROJECT_USER,
      },
      {
        name: "Personalrollen",
        show: PERMISSIONS.VIEW_FOREIGN_PROJECT_USERPOSITION,
        edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_USERPOSITION,
        delete: PERMISSIONS.DELETE_FOREIGN_PROJECT_USERPOSITION,
      },
      {
        name: "Dateiablage",
        show: PERMISSIONS.VIEW_FOREIGN_PROJECT_FILE,
        edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_FILE,
        delete: PERMISSIONS.DELETE_FOREIGN_PROJECT_FILE,
      },
      {
        name: "Konfiguration",
        show: PERMISSIONS.VIEW_FOREIGN_PROJECT_SETTINGS,
        edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_SETTINGS,
      },
      {
        name: "Abrechnen",
        show: PERMISSIONS.VIEW_FOREIGN_PROJECT_HOURLYWAGEINVOICE,
      },
      {
        name: "Nachkalkulation",
        show: PERMISSIONS.VIEW_FOREIGN_PROJECT_COSTS,
        edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_COSTS,
      },
      {
        name: "Leistungskatalog",
        show: PERMISSIONS.VIEW_FOREIGN_PROJECT_SERVICE_CATALOG,
        edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_SERVICE_CATALOG,
        delete: PERMISSIONS.DELETE_FOREIGN_PROJECT_SERVICE_CATALOG,
      },
      {
        name: "Projektphasen",
        show: PERMISSIONS.VIEW_FOREIGN_PROJECT_PHASE,
        edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_PHASE,
        delete: PERMISSIONS.DELETE_FOREIGN_PROJECT_PHASE,
      },
    ],
  },
  {
    name: "Personalplanung",
    children: [
      {
        name: "Personalplanung",
        show: PERMISSIONS.VIEW_PERSONNELPLANNING,
        edit: PERMISSIONS.EDIT_PERSONNELPLANNING,
        delete: PERMISSIONS.DELETE_PERSONNELPLANNING,
      },
    ],
  },
  {
    name: "Zeiterfassung",
    children: [
      {
        name: "Arbeitszeitmodelle",
        show: PERMISSIONS.VIEW_WORK_TIME_MODEL,
        edit: PERMISSIONS.EDIT_WORK_TIME_MODEL,
        delete: PERMISSIONS.DELETE_WORK_TIME_MODEL,
      },
      {
        // One tick, not a view/edit/delete triple: "Meine Zeiten" only ever makes sense whole — a
        // week you could read but not correct would be one you cannot fix either.
        name: "Eigene Zeiten erfassen",
        show: PERMISSIONS.RECORD_OWN_TIME,
      },
      {
        name: "Auf zugewiesene Projekte buchen",
        show: PERMISSIONS.BOOK_OWN_TIME_ASSIGNED_PROJECT,
      },
      {
        name: "Auf fremde Projekte buchen",
        show: PERMISSIONS.BOOK_OWN_TIME_FOREIGN_PROJECT,
      },
      {
        name: "Fremde Zeiten",
        show: PERMISSIONS.VIEW_TIME_ENTRY_FOREIGN,
        edit: PERMISSIONS.EDIT_TIME_ENTRY_FOREIGN,
        delete: PERMISSIONS.DELETE_TIME_ENTRY_FOREIGN,
      },
      {
        name: "Zeiten freigeben",
        show: PERMISSIONS.APPROVE_TIME_ENTRY,
      },
      {
        name: "Selbst erfasste Zeiten freigeben",
        show: PERMISSIONS.APPROVE_OWN_TIME_ENTRY,
      },
    ],
  },
  {
    name: "Preise",
    children: [
      {
        name: "Mitarbeiter-übersicht",
        children: [
          {
            name: "Lohn",
            show: PERMISSIONS.VIEW_USER_COMPANY_PAY,
            edit: PERMISSIONS.EDIT_USER_COMPANY_PAY,
          },
        ],
      },
      {
        name: "Maschinen-übersicht",
        children: [
          {
            name: "Einkaufspreis",
            show: PERMISSIONS.VIEW_MACHINE_PURCHASEPRICE,
            edit: PERMISSIONS.EDIT_MACHINE_PURCHASEPRICE,
          },
        ],
      },
      {
        name: "Material-übersicht",
        children: [
          {
            name: "Einkaufspreis",
            show: PERMISSIONS.VIEW_MATERIAL_PURCHASEPRICE,
            edit: PERMISSIONS.EDIT_MATERIAL_PURCHASEPRICE,
          },
        ],
      },
      {
        name: "Zusätzliche Leistungs-Übersicht",
        children: [
          {
            name: "Einkaufspreis",
            show: PERMISSIONS.VIEW_ADDITIONAL_EFFORT_PRICE,
            edit: PERMISSIONS.EDIT_ADDITIONAL_EFFORT_PRICE,
          },
        ],
      },
      {
        name: "Kundenübersicht",
        children: [
          {
            name: "Maschine: Einkaufspreis",
            show: PERMISSIONS.VIEW_CUSTOMER_MACHINE_PURCHASE_PRICE,
          },
          {
            name: "Machine: Verkaufspreis",
            show: PERMISSIONS.VIEW_CUSTOMER_MACHINE_SELLING_PRICE,
            edit: PERMISSIONS.EDIT_CUSTOMER_MACHINE_SELLING_PRICE,
          },
          {
            name: "Material: Einkaufspreis",
            show: PERMISSIONS.VIEW_CUSTOMER_MATERIAL_PURCHASE_PRICE,
          },
          {
            name: "Material: Verkaufspreis",
            show: PERMISSIONS.VIEW_CUSTOMER_MATERIAL_SELLING_PRICE,
            edit: PERMISSIONS.EDIT_CUSTOMER_MATERIAL_SELLING_PRICE,
          },
          {
            name: "Zusätzliche Leistung: Einkaufspreis",
            show: PERMISSIONS.VIEW_CUSTOMER_ADDITIONAL_EFFORT_PRICE,
          },
          {
            name: "Zusätzliche Leistung: Verkaufspreis",
            show: PERMISSIONS.VIEW_CUSTOMER_ADDITIONAL_EFFORT_SELLING_PRICE,
            edit: PERMISSIONS.EDIT_CUSTOMER_ADDITIONAL_EFFORT_SELLING_PRICE,
          },
          {
            name: "Personalposition: Stundenlohn",
            show: PERMISSIONS.VIEW_CUSTOMER_USER_HOURLY_PAY,
            edit: PERMISSIONS.EDIT_CUSTOMER_USER_HOURLY_PAY,
          },
        ],
      },
      {
        name: "Personalrollen-Übersicht",
        children: [
          {
            name: "Stundensätze",
            show: PERMISSIONS.VIEW_USER_POSITION_HOURLY_RATE,
            edit: PERMISSIONS.EDIT_USER_POSITION_HOURLY_RATE,
          },
        ],
      },
      {
        name: "Eigene-Projekte",
        children: [
          {
            name: "Maschine: Einkaufspreise",
            show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_MACHINE_PURCHASEPRICE,
            edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_MACHINE_PURCHASEPRICE,
          },
          {
            name: "Maschine: Verkaufspreise",
            show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_MACHINE_SELLINGPRICE,
            edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_MACHINE_SELLINGPRICE,
          },
          {
            name: "Material: Einkaufspreise",
            show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_MATERIAL_PURCHASEPRICE,
            edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_MATERIAL_PURCHASEPRICE,
          },
          {
            name: "Material: Verkaufspreise",
            show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_MATERIAL_SELLINGPRICE,
            edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_MATERIAL_SELLINGPRICE,
          },
          {
            name: "Zusätzliche Leistung: Einkaufspreise",
            show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_ADDITIONAL_EFFORT_PRICE,
          },
          {
            name: "Zusätzliche Leistung: Verkaufspreise",
            show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_ADDITIONAL_EFFORT_SELLINGPRICE,
            edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_ADDITIONAL_EFFORT_SELLINGPRICE,
          },
          {
            name: "Personalrollen: Stundensätze",
            show: PERMISSIONS.VIEW_ASSIGNED_PROJECT_USERPOSITION_HOURLYPAY,
            edit: PERMISSIONS.EDIT_ASSIGNED_PROJECT_USERPOSITION_HOURLYPAY,
          },
        ],
      },
      {
        name: "Fremde-Projekte",
        children: [
          {
            name: "Maschine: Einkaufspreise",
            show: PERMISSIONS.VIEW_FOREIGN_PROJECT_MACHINE_PURCHASEPRICE,
            edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_MACHINE_PURCHASEPRICE,
          },
          {
            name: "Maschine: Verkaufspreise",
            show: PERMISSIONS.VIEW_FOREIGN_PROJECT_MACHINE_SELLINGPRICE,
            edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_MACHINE_SELLINGPRICE,
          },
          {
            name: "Material: Einkaufspreise",
            show: PERMISSIONS.VIEW_FOREIGN_PROJECT_MATERIAL_PURCHASEPRICE,
            edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_MATERIAL_PURCHASEPRICE,
          },
          {
            name: "Material: Verkaufspreise",
            show: PERMISSIONS.VIEW_FOREIGN_PROJECT_MATERIAL_SELLINGPRICE,
            edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_MATERIAL_SELLINGPRICE,
          },
          {
            name: "Zusätzliche Leistung: Einkaufspreise",
            show: PERMISSIONS.VIEW_FOREIGN_PROJECT_ADDITIONAL_EFFORT_PRICE,
          },
          {
            name: "Zusätzliche Leistung: Verkaufspreise",
            show: PERMISSIONS.VIEW_FOREIGN_PROJECT_ADDITIONAL_EFFORT_SELLINGPRICE,
            edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_ADDITIONAL_EFFORT_SELLINGPRICE,
          },
          {
            name: "Personalrollen: Stundensätze",
            show: PERMISSIONS.VIEW_FOREIGN_PROJECT_USERPOSITION_HOURLYPAY,
            edit: PERMISSIONS.EDIT_FOREIGN_PROJECT_USERPOSITION_HOURLYPAY,
          },
        ],
      },
    ],
  },
]
